import { createLink } from '@tanstack/react-router'
import { Button, type ButtonProps } from '@journ/lotus/button'
import type { ComponentPropsWithRef } from 'react'

type ButtonAnchorProps = ComponentPropsWithRef<'a'> & Pick<ButtonProps, 'tone'>

const ButtonAnchor = ({ href = '', ...props }: ButtonAnchorProps) => <Button {...props} href={href} />

const ButtonLink = createLink(ButtonAnchor)

export { ButtonLink }
